import { Main } from "@hopper-ui/components";
import { PageLoader } from "@sg-protect/components";
import { Header, SkipToMain } from "@sg-protect/shell";
import { type PropsWithChildren, Suspense } from "react";
import { Outlet } from "react-router";
import { UserMenu } from "../UserMenu.tsx";

const NavBarHeight = "4.5rem";

export const AuthenticatedLayout = ({ children = <Outlet /> }: PropsWithChildren) => {
    return (
        <>
            <SkipToMain href="#main-content" />
            <Header userMenu={<UserMenu />} />
            <Main minWidth={0} UNSAFE_minHeight={`calc(100dvh - ${NavBarHeight})`} id="main-content" width="100%">
                <Suspense fallback={<PageLoader aria-label="Loading page…" />}>{children}</Suspense>
            </Main>
        </>
    );
};
